import { gql } from "@apollo/client";

export const RESEND_INVITE_EMAIL = gql`
  mutation($memberId: ID!) {
    resendInviteEmail(memberId: $memberId)
  }
`;
